/**
 * Seção "Exemplos de resposta" em modo leitura (Brief 4 · Tela 2 · PR2).
 *
 * Renderiza `examples[]` (situação + resposta exemplar) do serializer real.
 * `examples` pode vir `[]` → estado vazio honesto (a seção não some). Não
 * confundir com o bloco "Preview/Gerar resposta" do gabarito (OMITIDO: sem
 * backend de geração, seria dado falso).
 */

import type { PersonaExample } from '../types';

export function SectionExamplesRead({ examples }: { examples: PersonaExample[] }): JSX.Element {
  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Exemplos de resposta</h2>
      <p className="pe-panel__subtitle">Respostas exemplares que ancoram o comportamento da IA.</p>
      {examples.length > 0 ? (
        <div className="pe-examples">
          {examples.map((example) => (
            <article
              className="pe-example"
              key={`${example.situation}::${example.exemplaryResponse}`}
            >
              <span className="pe-field__label">Situação</span>
              <p className="pe-read-value">{example.situation}</p>
              <span className="pe-field__label">Resposta exemplar</span>
              <p className="pe-read-value pe-example__response">{example.exemplaryResponse}</p>
            </article>
          ))}
        </div>
      ) : (
        <p className="pe-read-value pe-read-value--muted">Nenhum exemplo cadastrado</p>
      )}
    </section>
  );
}
